export function formatGuideSaveMessage(baseMessage, response) {
  if (response?.kardex_recalculation?.status === 'queued') {
    return baseMessage;
  }

  return baseMessage;
}

export function buildRecalculateRunProgressMessage(run, pairsTotalFallback = 0) {
  const total = run?.pairs_total || pairsTotalFallback || 0;
  const done = run?.pairs_done ?? 0;

  if (run?.status === 'queued') {
    return `Recálculo en cola… ${total} par(es) pendientes`;
  }

  if (run?.is_active) {
    return `Recalculando kardex… ${done} / ${total} pares`;
  }

  if (run?.status === 'completed') {
    return `Recálculo completado: ${run.processed_pairs ?? 0} par(es), ${run.updated_movements ?? 0} movimientos actualizados.`;
  }

  if (run?.status === 'partial') {
    return `Recálculo con advertencias: ${run.processed_pairs ?? 0} procesados, ${run.failed_pairs ?? 0} fallidos.`;
  }

  if (run?.status === 'failed') {
    return run.error_message || 'El recálculo de kardex falló.';
  }

  return 'Recálculo de kardex finalizado.';
}

export function recalculateRunToastType(run) {
  if (!run || run.is_active) {
    return 'info';
  }
  if (run.status === 'completed') {
    return 'success';
  }
  if (run.status === 'partial') {
    return 'warning';
  }
  if (run.status === 'failed') {
    return 'error';
  }
  return 'info';
}

/** Mensaje combinado si la API devolvió advertencias de auditoría al guardar guía. */
export function formatAuditWarningsMessage(response) {
  const warnings = response?.audit_warnings;
  if (!Array.isArray(warnings) || warnings.length === 0) {
    return null;
  }
  return warnings.map((w) => w.message).filter(Boolean).join(' · ');
}

export function auditWarningsToastType(response) {
  const warnings = response?.audit_warnings;
  if (!Array.isArray(warnings) || warnings.length === 0) return 'info';
  if (warnings.some((w) => w.severity === 'critical')) return 'error';
  return 'warning';
}
